import React from "react";
const InputReadOnly = ({ label, content, theme, hasHtmlLabel = false }) => {
    return (React.createElement("div", { className: `inputReadOnly ${theme == 'light' ? 'inputReadOnly--light' : ''}` },
        hasHtmlLabel
            ? React.createElement("label", { dangerouslySetInnerHTML: { __html: label } })
            : React.createElement("label", null, label),
        React.createElement("p", null, content)));
};
export default InputReadOnly;
